document.addEventListener('DOMContentLoaded', function () {
  const reviewCards = Array.from(document.querySelectorAll('.ht-proof-v8__slider-track .ht-proof-v8__mini-card[data-quote]'));
  const allSlides = Array.from(document.querySelectorAll('.ht-proof-v8__slider-track .ht-proof-v8__mini-card'));
  const track = document.getElementById('htReviewTrack');
  const prevBtn = document.getElementById('htReviewPrev');
  const nextBtn = document.getElementById('htReviewNext');

  const mainImage = document.getElementById('htReviewMainImage');
  const mainQuote = document.getElementById('htReviewMainQuote');
  const mainMeta = document.getElementById('htReviewMainMeta');
  const mainScore = document.getElementById('htReviewMainScore');

  const modal = document.getElementById('htReviewModal');
  const openTop = document.getElementById('htOpenReviewModalTop');
  const openCard = document.getElementById('htOpenReviewModalCard');
  const closeBtn = document.getElementById('htReviewModalClose');
  const backdrop = document.getElementById('htReviewModalBackdrop');

  const reviewForm = document.getElementById('htReviewForm');
  const reviewName = document.getElementById('htReviewName');
  const reviewRating = document.getElementById('htReviewRating');
  const reviewMessage = document.getElementById('htReviewMessage');
  const reviewSuccess = document.getElementById('htReviewSuccess');
  const modalStarBtns = Array.from(document.querySelectorAll('.ht-proof-v8__modal-star-btn'));
  const modalStarLabel = document.getElementById('htModalStarLabel');
  const reviewCtaCard = document.getElementById('htReviewCtaCard');

  if (!track || !reviewCards.length || !allSlides.length) return;

  let currentReviewIndex = 0;
  let currentSlideIndex = 0;
  let autoTimer = null;

  function setMainReview(card) {
    if (!card || !mainImage || !mainQuote || !mainMeta || !mainScore) return;

    reviewCards.forEach(c => c.classList.remove('is-active'));
    card.classList.add('is-active');

    mainImage.classList.add('is-changing');
    mainQuote.classList.add('is-changing');
    mainMeta.classList.add('is-changing');
    mainScore.classList.add('is-changing');

    setTimeout(() => {
      mainImage.src = card.dataset.image || mainImage.src;
      mainQuote.textContent = card.dataset.quote || '';
      mainMeta.innerHTML = '<span>' + (card.dataset.name || '') + '</span><span>' + (card.dataset.tag || '') + '</span>';
      mainScore.textContent = card.dataset.score || '4.9';

      mainImage.classList.remove('is-changing');
      mainQuote.classList.remove('is-changing');
      mainMeta.classList.remove('is-changing');
      mainScore.classList.remove('is-changing');
    }, 240);
  }

  function slideWidth() {
    const first = allSlides[0];
    if (!first) return 0;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || 14) || 14;
    return first.getBoundingClientRect().width + gap;
  }

  function visibleCount() {
    return window.innerWidth <= 749 ? 1 : 2;
  }

  function updateSlider() {
    if (!track) return;
    const maxIndex = Math.max(0, allSlides.length - visibleCount());
    if (currentSlideIndex > maxIndex) currentSlideIndex = maxIndex;
    const move = slideWidth() * currentSlideIndex;
    track.style.transform = 'translateX(-' + move + 'px)';
  }

  function goNext() {
    const maxIndex = Math.max(0, allSlides.length - visibleCount());
    currentSlideIndex = currentSlideIndex >= maxIndex ? 0 : currentSlideIndex + 1;
    updateSlider();
  }

  function goPrev() {
    const maxIndex = Math.max(0, allSlides.length - visibleCount());
    currentSlideIndex = currentSlideIndex <= 0 ? maxIndex : currentSlideIndex - 1;
    updateSlider();
  }

  function nextReview() {
    currentReviewIndex = (currentReviewIndex + 1) % reviewCards.length;
    setMainReview(reviewCards[currentReviewIndex]);

    const targetSlideIndex = currentReviewIndex;
    const maxIndex = Math.max(0, allSlides.length - visibleCount());
    currentSlideIndex = Math.min(targetSlideIndex, maxIndex);
    updateSlider();
  }

  function startAuto() {
    clearInterval(autoTimer);
    autoTimer = setInterval(nextReview, 3400);
  }

  function restartAuto() {
    clearInterval(autoTimer);
    startAuto();
  }

  reviewCards.forEach((card, index) => {
    card.addEventListener('click', function () {
      currentReviewIndex = index;
      currentSlideIndex = Math.min(index, Math.max(0, allSlides.length - visibleCount()));
      setMainReview(card);
      updateSlider();
      restartAuto();
    });
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goNext();
      restartAuto();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goPrev();
      restartAuto();
    });
  }

  function openModal() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (openTop) openTop.addEventListener('click', openModal);
  if (openCard) openCard.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function setModalStars(value) {
    if (!reviewRating || !modalStarLabel) return;

    reviewRating.value = String(value);
    modalStarBtns.forEach(btn => {
      btn.classList.toggle('is-on', Number(btn.dataset.value) <= value);
    });
    modalStarLabel.textContent = value + ' / 5';
  }

  modalStarBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      setModalStars(Number(this.dataset.value));
    });
  });

  if (reviewForm) {
    reviewForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const name = reviewName ? reviewName.value.trim() : '';
      const rating = reviewRating ? reviewRating.value.trim() : '';
      const message = reviewMessage ? reviewMessage.value.trim() : '';

      if (!name || !rating || !message) {
        alert('Please fill your name, choose stars, and write your review.');
        return;
      }

      if (reviewSuccess) reviewSuccess.style.display = 'block';

      if (reviewCtaCard) {
        const stars = '★★★★★'.slice(0, Number(rating));
        reviewCtaCard.className = 'ht-proof-v8__mini-card';
        reviewCtaCard.setAttribute('data-score', Number(rating).toFixed(1));
        reviewCtaCard.setAttribute('data-quote', '“' + message + '”');
        reviewCtaCard.setAttribute('data-name', name);
        reviewCtaCard.setAttribute('data-tag', 'Fresh review');
        reviewCtaCard.setAttribute('data-image', 'https://cdn.shopify.com/s/files/1/0756/6920/9188/files/Screenshot_2026-04-21_020446.png?v=1776717537');

        reviewCtaCard.innerHTML = `
          <div class="ht-proof-v8__mini-rating">
            <span class="ht-proof-v8__mini-stars">${stars.padEnd(5, '☆')}</span>
            <span class="ht-proof-v8__mini-pill">${Number(rating).toFixed(1)}</span>
          </div>
          <span class="ht-proof-v8__chip">FRESH REVIEW</span>
          <p>“${message}”</p>
          <span class="ht-proof-v8__mini-meta">${name}</span>
        `;

        reviewCards.push(reviewCtaCard);

        reviewCtaCard.addEventListener('click', function () {
          const idx = reviewCards.indexOf(reviewCtaCard);
          currentReviewIndex = idx;
          currentSlideIndex = Math.min(idx, Math.max(0, allSlides.length - visibleCount()));
          setMainReview(reviewCtaCard);
          updateSlider();
          restartAuto();
        });
      }

      setTimeout(() => {
        if (reviewSuccess) reviewSuccess.style.display = 'none';
        reviewForm.reset();
        if (reviewRating) reviewRating.value = '';
        modalStarBtns.forEach(btn => btn.classList.remove('is-on'));
        if (modalStarLabel) modalStarLabel.textContent = 'Tap stars to rate';
        closeModal();
      }, 900);
    });
  }

  window.addEventListener('resize', updateSlider);

  updateSlider();
  startAuto();
});